import React, { useState, useEffect } from "react";

import "./styles.css";
import { Row, Col, Button, Input } from "antd";
import {
  CloseOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";

export default function GlobalSearchSection1(props) {
  const {
    t,
    appLanguage,
    // tagNameFromUrl,

    // search handle
    searchKeyword,
    setSearchKeyword,
    onSubmit,
    // selected tag
    setSelectedTag,
    selectedTag,

    // selected year
    selectedYear,
    setSelectedYear,

    // tags
    tagListThemes,
    tagListCategories,
    yearList,
    // sort
    currentSorting,
    setCurrentSorting,
    // filter
    clearFilter,
    filterType,
    setFilterType
  } = props;

  let [showFilterBar, setShowFilterBar] = useState(false);


  const toggleShowFilterBar = () => {
    setShowFilterBar(!showFilterBar);
  };
  const closeShowFilterBar = () => {
    setShowFilterBar(false);
    setFilterType(null)
  };
  const showFilterBarSection = () => {
    setShowFilterBar(true);
  };

  // select the  tag  if there is  any tag  selected
  // useEffect(() => {
  //   if (tagNameFromUrl) {
  //     setSelectedTag(tagNameFromUrl);
  //     setShowFilterBar(true);
  //   }
  // }, [tagNameFromUrl]);



  return (
    <div>
      <div className="globalsearchsection1__container">
        <Row>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 24 }}
            xxl={{ span: 24 }}
          >
            {/* <p className="globalsearchsection1__text">Global Search</p> */}
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 24 }}
            xxl={{ span: 24 }}
          >
            <div className="globalsearchsection1__search-box">
              <Input
                autoFocus
                onPressEnter={(e) => {
                  onSubmit(e.target.value.trim());
                }}
                value={searchKeyword}
                onChange={(e) => {
                  setSearchKeyword(e.target.value);
                }}
                placeholder={`${t("Search Query Here")}`}
                className="placeholder-f-s-1-6em"

              />
              <div className="flex-row-align-items-center">
                <Button
                  className={
                    filterType === "tag"
                      ? "search-filter-active"
                      : "search-filter"
                  }
                  onClick={() => {
                    if (filterType === "tag") {
                      closeShowFilterBar();
                      return
                    }
                    showFilterBarSection();
                    setFilterType("tag");
                  }}
                >
                  {t("Filter")}
                </Button>
                <Button
                  className={
                    filterType === "year"
                      ? "search-filter-active mar-l-10"
                      : "search-filter mar-l-10"
                  }
                  onClick={() => {
                    if (filterType === "year") {
                      closeShowFilterBar();
                      return
                    }
                    showFilterBarSection();
                    setFilterType("year");
                  }}
                >
                  {t("Year")}
                </Button>

                <span className="mar-l-10 fs-1-3em">
                  <DownOutlined onClick={() => { setCurrentSorting('DESC') }}
                    className={currentSorting === 'DESC' ? 'sort-btn-active' : 'sort-btn'}
                  />
                </span>
                <span className="fs-1-3em mar-l-10 ">
                  <UpOutlined onClick={() => { setCurrentSorting('ASC') }}
                    className={currentSorting === 'ASC' ? 'sort-btn-active' : 'sort-btn'}
                  />
                </span>

              </div>
            </div>
          </Col>
          {showFilterBar && (
            <>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 24 }}
                xl={{ span: 24 }}
                xxl={{ span: 24 }}

              >
                {filterType === "tag" && (
                  <div>
                    <div className="flex-row-justify-space-between ">
                      <div className="tag-list">
                        {(tagListThemes || []).map((tag) => {
                          return (
                            <p
                              key={tag}
                              className={
                                selectedTag?.toLowerCase() === tag?.toLowerCase()
                                  ? "tag-item-active mar-b-10"
                                  : "tag-item mar-b-10"
                              }
                              onClick={() => {
                                if (selectedTag === tag) {
                                  setSelectedTag(null)
                                  return
                                }
                                setSelectedTag(tag)
                              }}
                            >
                              <span className="uppercasetext">{t(`${tag}`)}</span>
                            </p>
                          );
                        })}
                      </div>
                      <div className="trianglesection1__filter-close"  >
                      <CloseOutlined
                        className="closebtn"
                        onClick={() => {
                          closeShowFilterBar();
                          setFilterType(null)
                          clearFilter();
                        }}
                      />
                    </div>
                    </div>

                    <div className="flex-row-justify-space-between" style={{marginTop: "10px"}}>
                      <div className="tag-list">
                        {tagListCategories.map((tag) => {
                          return (
                            <p
                              key={tag}
                              className={
                                selectedTag?.toLowerCase() === tag?.toLowerCase()
                                  ? "tag-item-active mar-b-10"
                                  : "tag-item mar-b-10"
                              }
                              onClick={() => {
                                if (selectedTag === tag) {
                                  setSelectedTag(null)
                                  return
                                }
                                setSelectedTag(tag)
                              }}
                            >
                              <span className="uppercasetext">{t(`${tag}`)}</span>
                            </p>
                          );
                        })}
                      </div>
                    </div>

             
                  </div>
                )}
              {filterType === "year" && (
                <div className="flex-row-justify-space-between ">
                  <div className="tag-list">
                    {yearList.map((year) => {
                      return (
                        <p
                          key={year}
                          className={
                            selectedYear === year
                              ? "tag-item-active mar-b-10"
                              : "tag-item mar-b-10"
                          }
                          onClick={() => {
                            if (selectedYear === year) {
                              setSelectedYear(null)
                              return
                            }
                            setSelectedYear(year)
                          }}
                        >
                          {t(`${year}`)}
                        </p>
                      );
                    })}
                  </div>
                  <div className="previousprogramssearch____filter-close">
                    <CloseOutlined
                      className="closebtn"
                      onClick={() => {
                        closeShowFilterBar();
                        setFilterType(null)
                        clearFilter();
                      }}
                    />
                  </div>
                </div>
              )}
            </Col>
          <Col span={24} className=" mar-b-20">

          </Col>
        </>
          )}
      </Row>
    </div>
    </div >
  );
}
